export default __webpack_public_path__ + "static/media/Goldplay-SemiBold.43135116.otf";